import { InferType, object, string } from 'yup';
import { confirmPasswordSchema, passwordSchema } from '../Landing/helpers/validation';

export const validationSchema = object({
  currentPassword: string().required('error.passwordRequired'),
  password: passwordSchema,
  confirmPassword: confirmPasswordSchema
});

export type Schema = InferType<typeof validationSchema>;
